var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aa69ea58-0223-42e3-bc0b-da3cad20af37",
    "data-name": "Warning",
    viewBox: "0 0 16.79 14.62",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b76aeed4-253e-4390-8d72-3e9108ed67db",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e6c7a142-b3bb-4307-8de4-7c988584987c",
    "data-name": "Group 541",
    transform: "translate(-0.50214061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f4b89354-4d43-4544-b3d7-a5c5acca1344",
    "data-name": " ",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.4,11.23)",
    style: {
      fontWeight: 700,
      fontSize: 9,
      fontFamily: "Arial-BoldMT, Arial",
      isolation: "isolate"
    },
    id: "text1"
  }, "!"))), /*#__PURE__*/React.createElement("g", {
    id: "f495cbcc-a6d4-4299-bd40-b9febb6ee440",
    "data-name": "Polygon 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7.94A2,2,0,0,1,9.45.3a2.06,2.06,0,0,1,.64.64l6.39,10.23a2,2,0,0,1-.63,2.75,2,2,0,0,1-1.07.31H2a2,2,0,0,1-2-2,2,2,0,0,1,.3-1.06Z",
    style: {
      fill: "none"
    },
    id: "path1"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4,1a1,1,0,0,0-.85.47L1.16,11.7a1,1,0,0,0,0,1,1,1,0,0,0,.87.52H14.79a1,1,0,0,0,.85-1.53L9.24,1.47A1,1,0,0,0,8.4,1m0-1a2,2,0,0,1,1.69.94l6.39,10.23a2,2,0,0,1-1.69,3.06H2A2,2,0,0,1,.31,11.17L6.7.94A2,2,0,0,1,8.4,0Z",
    id: "path2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.242a18b79124e778cb87b654c96332f8.svg";
export { ForwardRef as ReactComponent };